import JsBarcode from "jsbarcode";

/**
 * Generate a PNG data URL for a barcode. Accepts any string — numbers,
 * letters, or a mix (Amazon ASIN, SKU, custom code). We pick EAN13/EAN8 only
 * when the input is exactly the right length of digits; otherwise CODE128 so
 * anything alphanumeric still scans. Rendering this ONCE and reusing it as an
 * <img> avoids drawing thousands of SVGs when tiling a large batch on A4.
 */
export function generateBarcodeDataUrl(value, opts = {}) {
  if (value == null) return null;
  const raw = String(value).trim();
  if (raw.length < 1) return null;
  const digitsOnly = /^\d+$/.test(raw);
  const format =
    digitsOnly && raw.length === 13
      ? "EAN13"
      : digitsOnly && raw.length === 8
      ? "EAN8"
      : "CODE128";
  const canvas = document.createElement("canvas");
  try {
    JsBarcode(canvas, raw, {
      format,
      width: 2,
      height: 40,
      fontSize: 18,
      textMargin: 2,
      margin: 0,
      displayValue: true,
      background: "#ffffff",
      lineColor: "#000000",
      ...opts,
    });
    return canvas.toDataURL("image/png");
  } catch (e) {
    // Fall back to CODE128 if EAN was chosen but checksum/format invalid.
    try {
      const canvas2 = document.createElement("canvas");
      JsBarcode(canvas2, raw, {
        format: "CODE128",
        width: 2,
        height: 40,
        fontSize: 18,
        textMargin: 2,
        margin: 0,
        displayValue: true,
        background: "#ffffff",
        lineColor: "#000000",
        ...opts,
      });
      return canvas2.toDataURL("image/png");
    } catch {
      return null;
    }
  }
}
